import $ from "jquery";
import {gsap} from "gsap/all";
import {Flip} from "gsap/Flip";

gsap.registerPlugin(Flip);

export class Message {

  constructor($container) {
    this.$container = $container;
    this.$scrollable = $container.closest('.chatroom-wrapper');
    this.$currentGroup = null;
    this.$currentSide = null;

    this.tl = gsap.timeline();
    this.blur = $('#blurFilter feGaussianBlur');

  }

  scrollToBottom(duration = 0.5) {
    const el = this.$scrollable[0];
    return gsap.to(el, {
      scrollTop: el.scrollHeight - el.clientHeight,
      duration,
      ease: 'power2.out'
    });
  }

  scrollToTop() {
    this.$container.addClass('scroll-up');

    const tl = gsap.timeline();

    tl.to(this.blur, {
      attr: {stdDeviation: 2},
      duration: 0.5,
      ease: 'power1.inOut'
    });

    tl.to(this.$container[0], {
      y: this.$scrollable[0].clientHeight,
      duration: 2,
      ease: 'power2.inOut',
      onComplete: () => {
        this.$container.removeClass('scroll-up');
      }
    }, '<');

    // Moved go to screen out of onComplete so it appears while we are still scrolling
    tl.add(() => {
      app.goToNextScreen();
    }, '-=0.5');
  }

  appendToBubble(side, $bubble) {
    //This runs getBoundingClientRect() on every matched element before you touch the DOM
    //The browser will recalculate the layout
    const state = Flip.getState(this.$container.find('.message-bubble, .mars-e-avatar'));

    if (side !== this.$currentSide) {
      this.$currentGroup = $(`<div class="message-group message-group-${side}"></div>`);

      if (side === 'left') {
        this.$currentGroup.append('<div class="mars-e-avatar"></div>');
      }

      this.$container.append(this.$currentGroup);
      this.$currentSide = side;
    }
    this.$currentGroup.append($bubble);

    //Measures the current (new) position/size of every element that's in state
    //Compares new rect vs. old
    //Then it animates that transform
    Flip.from(state, {
      duration: 0.4,
      ease: 'power2.out',
      nested: true
    });

    this.scrollToBottom();
  }

  addMessage(text, side = 'left', delay = 0.2, $emoji = false) {
    return new Promise((resolve) => {

      const showThinking = side === 'left';

      const $bubble = $(`
      <div class="message-bubble message-${side}">
          ${showThinking ? `
          <div class="thinking-animation">
           <span></span>
           <span></span>
           <span></span>
          </div>` : ''}
          <div class="bubble-inner">${text}</div>
      </div>
      `);

      if ($emoji) this.appendToBubble(side, $emoji);
      this.appendToBubble(side, $bubble);

      const tl = gsap.timeline();

      // DEBUG UTILITY
      // tl.timeScale(10);

      if (showThinking) {
        tl.to($bubble.find('.thinking-animation'), {
          opacity: 1,
          duration: 0.3,
          ease: 'power1.out'
        }, 0);

        tl.add(() => {
          this.$currentGroup.addClass('icon-visible');
        }, 0);
      }

      // Then pop in the bubble itself
      tl.fromTo($bubble,
        {opacity: 0},
        {
          opacity: 1,
          duration: 0.4,
          ease: "back.out(3)"
        });

      // Hold on "typing" (only relevant if dots exist)
      if (showThinking) {
        tl.to($bubble.find('.thinking-animation'), {
          opacity: 0,
          scale: 0.5,
          duration: 0.2
        }, `+=0.1`);
      }

      // Remove dots (if any), swap in the text
      tl.add(() => {
        $bubble.find('.thinking-animation').remove();
      });

      // Text fades + slides in
      const animatables = [$bubble, $emoji].reduce((acc, el) => {
        if (el) acc.push(el.find('.bubble-inner'))
        return acc;
      }, []);
      tl.fromTo(animatables,
        {
          opacity: 0,
          y: 5,
          scale: 0.9
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.4,
          ease: "back.out(5)"
        }
      );

      tl.add(() => {
        resolve();
      }, `+=${delay}`);
    });
  }

  addEmojiAndMessage(text, icon, side = 'left', delay = 0.2) {
    const $bubble = $(`
        <div class="message-bubble message-${side} message-emoji">
          <div class="bubble-inner">
            <img src="${icon}" />
          </div>
        </div>
      `);
    return this.addMessage(text, side, delay, $bubble);
  }

  reset() {
    Flip.killFlipsOf(this.$container.find('.message-bubble, .mars-e-avatar'));

    this.$container.empty();
    this.$currentGroup = null;
    this.$currentSide = null;

    this.$container.removeClass('scroll-up');

    this.tl.kill();
    this.tl = gsap.timeline();

    this.tl.set(this.$container[0], {clearProps: 'all'});

    // reset blur
    this.tl.set(this.blur, {
      attr: {stdDeviation: 0},
    });
  }
}
